// DetailDescription — section 4. Canonical detail.html lines 439–466.
//
// Public block: split description_public on blank lines into <p>
// paragraphs (plain text only — per CLAUDE.md textarea constraint).
//
// Private block — STOP per R3 plan:
//   * description_private exists on the model (verified)
//   * BUT realtor-role predicate `is_realtor` is NOT defined on the
//     User model (verified in apps/users/serializer.py)
//   * Classification C — backend-truth-missing for the gating predicate
//   * Render: lock header preserved, body muted-em-dash + TODO.
//
// MUST NOT: render description_private content; infer is_realtor
// from any combination of existing fields.

const splitParagraphs = (text) => {
  if (!text || typeof text !== "string") return [];
  return text
    .split(/\n\s*\n/g)
    .map((paragraph) => paragraph.trim())
    .filter((paragraph) => paragraph.length > 0);
};

function DetailDescription({ property, canViewPrivateDescription }) {
  const publicParagraphs = splitParagraphs(property.description_public);
  const privateParagraphs = splitParagraphs(property.description_private);

  return (
    <section className="detail-description">
      <div className="container">
        <div className="row">
          <h2 className="section-title">Опис</h2>

          <article className="desc-card desc-card--public">
            {publicParagraphs.length > 0 ? (
              publicParagraphs.map((paragraph, index) => (
                <p key={index}>{paragraph}</p>
              ))
            ) : (
              <p>
                <span className="muted">—</span>
              </p>
            )}
          </article>

          <article
            className="desc-card desc-card--private"
            aria-label="Приватний опис"
          >
            <header className="desc-card__lock">
              <i className="fa-solid fa-lock" aria-hidden="true" />
              <span>Нотатки для рієлторів</span>
              <small>Видно тільки авторизованим рієлторам</small>
            </header>
            {/* R3.9 — canViewPrivateDescription is currently the
                isOwner subset of the eventual "any authorized
                realtor" predicate. Non-owner viewers see the
                muted placeholder until backend exposes is_realtor;
                owner sees their own private notes. */}
            {canViewPrivateDescription ? (
              privateParagraphs.length > 0 ? (
                privateParagraphs.map((paragraph, index) => (
                  <p key={index}>{paragraph}</p>
                ))
              ) : (
                <p>
                  <span className="muted">—</span>
                </p>
              )
            ) : (
              <p>
                <span className="muted">—</span>
              </p>
            )}
          </article>
        </div>
      </div>
    </section>
  );
}

export default DetailDescription;
